const inventoryErrorService = (manageHandleErrorService, customErrors) => {
    // ideally to merge customReason into manageHandleErrorService, Angular didn't like it,
    // passing by angular.value
    customErrors['longDescription with value.*'] = 'There was a problem saving. ' +
        'The Long Description field exceeds the number of characters permitted. ' +
        'Reduce the number of characters in the Long Description field and try saving again.';

    return Object.assign({}, manageHandleErrorService);
}

angular
    .module('qkr.inventory')
    .factory('inventoryErrorService', inventoryErrorService);




// WEBPACK FOOTER //
// ./src/inventory/services/inventory.error.service.js